<template>
  <div class="header-component">
    <div class="wrapper">
      <div class="container">
        <div class="menu-back-button">
          <img
            v-if="hasBackLink"
            class="exit"
            @click="navigateBack"
            src="/images/header/backico.png"
          />
        </div>
        <div
          v-if="productTheme.preLogoImg"
        >
        <img :src="productTheme.preLogoImg" class="hk-logo pre-logo"/>
        </div>
        <div
          class="menu-header"
          :class="{ change_logo_height: changeLogoHeight }"
        >
          <img @click="navigateHome" class="bar" :src="productTheme.logo" />
        </div>
        <div
         v-if="productTheme.postLogoImg"
        >
          <img :src="productTheme.postLogoImg" class="hk-logo post-logo"/>
        </div>

        <div class="menu-toggle">
          <img
            :class="{ inactive: !mobileMenuActive, active: mobileMenuActive }"
            src="/images/header/Menu.png"
            class="menu-btn"
            @click="openMenu()"
          />
        </div>
      </div>
    </div>

    <!-- Mobile Menu for displaying all the option -->
    <MobileMenu
      :class="{ visible: mobileMenuActive }"
      class="mobile-menu"
      @close="closeMenu"
    ></MobileMenu>
    <div
      v-if="isSubdomainUMOBILE"
      class="Unsub_btn"
      @click="redirectToUnsubPage()"
    >
      <span>Unsubscribe Service</span>
    </div>
  </div>
</template>

<script>
import MobileMenu from "./mobile-menu.component.vue";
import { getScene, getState, transitionTo } from "../utils/aframe.utils";
import { isMobioVr, isXRZONE } from "../utils/isMobioVr.utils";
import { getUnsubLink } from "../utils/unsub.utils";
import { config } from "../helpers/domain-config";
import { getDomainTheme } from "../utils/domains-theme";
import { changeLogoHeightDomains, PRODUCT_HK_XR_A, productNameMap } from "../helpers/page-constants";

export default {
  components: {
    MobileMenu,
  },
  data: () => ({
    hasBackLink: false,
    mobileMenuActive: false,
    isSubdomainUMOBILE: config.subdomain === "umobile",
    changeLogoHeight: changeLogoHeightDomains.includes(config.productName),
  }),
  computed: {
    productTheme: () => getDomainTheme(config.productName),
  },
  created() {
    getScene().addEventListener("clearBackLink", (e) => {
      this.hasBackLink = false;
    });
    getScene().addEventListener("setBackLink", (e) => {
      this.hasBackLink = e.data !== null;
    });
  },
  methods: {
    navigateBack() {
      const backScene = getScene().systems["router"].getBackScene(getState().backLink);
      transitionTo(backScene.split("/"));
    },
    navigateHome() {
      transitionTo([""]);
    },
    openMenu() {
      this.mobileMenuActive = true;
      document.body.classList.add("mobile-menu-active");
      const Div = document.createElement("div");
      Div.className = "blurr-bg";
      const Blurrbg = document.querySelectorAll(".blurr-bg");
      if (Blurrbg.length === 0) {
        const x = document.querySelector(".has-vue-page");
        if (x) x.prepend(Div);
      }
    },
    closeMenu() {
      this.mobileMenuActive = false;
      document.body.classList.remove("mobile-menu-active");
      const x = document.querySelector(".blurr-bg");
      if (x) x.remove();
    },
    redirectToUnsubPage: function (pkgId) {
      const redirectUrl = getUnsubLink(pkgId);
      if (typeof redirectUrl === "string") {
        window.location.href = redirectUrl;
      }
    },
  },
};
</script>
<style lang="scss">
.header-component {
  position: fixed;
  height: 7.5vh;
  width: 100%;
  z-index: 10;

  &.animated {
    transition: 1s;

    .left,
    .right {
      transition: 1s;
      transition-delay: 1.25s;
    }
  }

  &.visible {
    top: 2px;

    .left,
    .right {
      opacity: 1;
    }
  }

  .wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Unsub_btn {
    height: 100%;
    display: flex;
    justify-content: center;
    margin: -5px;
    pointer-events: all;
    cursor: pointer;

    span {
      display: flex;
      align-items: center;
      color: red;
      background-color: white;
      margin: 8px;
      padding: 6px;
    }
  }

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    background: #000000;
    padding: 2px 34px;
    border-radius: 80px;
    max-width: 60%;
    width: 510px;

    .menu-toggle,
    .menu-back-button {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      height: 65%;
      width: 3%;
      img {
        padding: 7px;
        border-radius: 50%;
      }
    }
    .menu-back-button {
      img {
        @media (hover: hover) {
          &:hover {
            background-color: rgba(64, 64, 64, 1);
          }
        }
      }
    }
    .menu-toggle {
      img {
        &:hover {
          background-color: rgba(64, 64, 64, 1);
        }
        &.active {
          background-color: rgba(64, 64, 64, 1);
          cursor: not-allowed;
        }
      }
    }
    .menu-header {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 24%;
    }
    .change_logo_height {
      height: 70%;
    }
    img {
      height: 100%;
      &.bar {
        cursor: pointer;
        max-width: 500px;
        pointer-events: all;
      }
    }
    .hk-logo{
       max-height: 100px;
       object-fit: contain;
    }
    .post-logo{
      height: 80px;
    }
    .pre-logo{
      height: 60px;
    }
  }
  .mobile-menu {
    margin-left: 100vw;

    &.visible {
      margin-left: 0;
    }
  }
}
@media screen and (max-width: 1024px) {
  .header-component {
    .container {
      padding: 0px 45px;
      .menu-header {
        height: 22%;
      }
      .menu-back-button {
        img {
          &:active {
            background-color: rgba(64, 64, 64, 1);
          }
          &:not(:active) {
            transition: background-color 0.5s;
          }
        }
      }
    }
    &.visible {
      top: 0;
    }
  }
}
@media screen and (max-width: 640px) {
  .header-component {
    .container {
      max-width: 84%;
      padding: 0px 17px;
      margin: unset;

      .menu-back-button,
      .menu-toggle {
        height: 54%;
        width: 9%;
        img {
          padding: 6px;
        }
      }
      .menu-header {
        width: 80%;
        height: 20%;
      }
    }
    img {
      &.bar {
        margin: 0;
      }
    }
    .change_logo_height {
      height: 56% !important;
    }
  }
}
@media screen and (max-width: 320px) {
  .header-component {
    .container {
      width: 82% !important;
      padding: 4px 17px;
    }
  }
}
@media screen and (max-width: 900px) and (max-height: 414px) and (orientation: landscape) {
  .header-component {
    .container {
      width: 350px;
      margin-top: 1.7%;
      padding: 8px 30px !important;
      .menu-toggle,
      .menu-back-button {
        height: 76%;
      }
      .menu-header {
        height: 42%;
      }
    }
  }
}
</style>
